<template>
  <div>
    <Header :active="active" @navChilIndex="getnavChilIndex" />
    <img :src="top_slogan" alt="" class="banner-img" />
    <div class="w1300">
      <div class="content-nav">
        <span @click="goIndex()">首页</span>> <span>巾帼家政</span>><span>{{ title }}</span>
      </div>
      <div class="box">
        <div class="tab">
          <ul>
            <li
              :class="activeId == item.id ? 'active' : ''"
              v-for="(item, index) in tabList"
              :key="index"
              @click="tabIndex(item.id,item.title)"
            >
              {{ item.title }}
            </li>
          </ul>
        </div>
        <div v-if="activeId == 20" class="list">
          <ul>
            <li v-for="(item, index) in articleList" :key="index" @click="goInfo(item.id,item.url)">
              <div class="li-left">{{item.title}}</div>
              <div class="li-right">{{item.time}}
                <img src="../assets/images/19.png" alt="">
              </div>
            </li>
          </ul>
        </div>
        <div class="list1" v-else>
          <ul>
            <li v-for="(item, index) in articleList" :key="index" @click="goInfo(item.id,item.url)">
              <img :src="imgUrl + item.image" alt="" class="img_left"/>
              <div class="right">
                <div>
                  <p class="name">{{item.title}}</p>
                  <p>{{item.remark}}</p>
                </div>
                <img src="../assets/images/19.png" alt="">
              </div>
            </li>
          </ul>
        </div>
      </div>
      <el-pagination
            layout="prev, pager, next"
            :total="total"
            :current-page="currentPage"
            @current-change="handleCurrentChange"
            style="float: right"
            v-if="total > 10"
          >
          </el-pagination>
    </div>
    <Foot />
  </div>
</template>
  <script>
import Header from "../components/header.vue";
import Foot from "../components/foot.vue";
export default {
  components: {
    Header,
    Foot,
  },
  data() {
    return {
      active: 3,
      articleList: [],
      tabList: [],
      activeId: "",
      title: "",
      imgUrl:this.$imgUrl,
      children_id:'',
      total: "",
      currentPage:1,
      pageSize: 10,
      top_slogan:this.$imgUrl + localStorage.getItem('top_slogan')
    };
  },
  mounted() {
    let cate_id = this.$route.params.cate_id;
    this.children(cate_id)
    let id = this.$route.params.id;
    this.children_id = id;
    this.activeId = id;
    this.list(id);
  },
  methods: {
    tabIndex(index,title) {
      this.activeId = index;
      this.title = title
      this.list(index)
      this.$router.push('/jinguojiazheng/'+this.active+'/'+index,()=>{},()=>{});
    },
    getnavChilIndex(index) {
      this.activeId = index;
    },
    async children(id){
      let res = await this.$get('/web/index/children',{id:id})
      if(res.code == 200){
        this.tabList = res.data
        this.tabList.forEach((item)=>{
          if(item.id == this.children_id){
            this.title = item.title
          }
        })
      }
    },
    async list(id){
      let data ={
        cateId:id,
        pageNum:this.currentPage,
        pageSize:this.pageSize
      }
      let res = await this.$get('/web/news/list',data)
      if(res.code == 200){
        this.articleList = res.rows
        this.total = res.total;
      }
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.list(this.children_id)
    },
    goInfo(id,url) {
      if(url !== null && url !== undefined && url !== ""){
        window.open(url);
      }else{
        this.$router.push("/jinguoinfo/" + id + "/巾帼家政/" + this.title);
      }
    },
    goIndex(){this.$router.push('/')}
  },
};
</script>
  <style scoped>
.content-nav {
  border-bottom: solid 1px #bb030d;
  padding: 15px 0;
  font-size: 15px;
  margin-top: 15px;
  margin-bottom: 40px;
}
.content-nav span {
  margin-right: 10px;
  margin-left: 10px;
  color: #727272;
}
.banner-img{width: 1300px;margin: 0 auto;margin-top: 20px;display: block;}
.box {
  display: flex;
}
.list,.list1{margin-left: 75px;width: 100%;}
.list ul li,.list1 ul li{display: flex;border-bottom: solid 1px #efefef;padding-bottom: 25px;margin-bottom: 35px;}
.list ul li:hover{cursor: pointer;}
.li-right{display: flex;font-size: 15px;color: #696969;align-items: center;}
.li-left{ flex: 1;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;margin-right: 60px;}
.li-right img,.right img{width: 25px;height: 25px;margin-left: 10px;}
.img_left{width: 140px;height: 160px;} 
.list1 .right{margin-left: 20px;display: flex;width: 100%;align-items: center;}
.right>div {width: 95%;}
.right .name{font-size: 17px;margin-bottom: 15px;}
.right p{font-size: 15px;line-height: 25px;}
.tab ul li {
  width: 200px;
  text-align: center;
  height: 50px;
  line-height: 50px;
  margin-bottom: 30px;
  background-color: #f4f5f9;
}
.tab ul .active {
  background-color: #bc0404;
  color: #fff;
}
.tab ul li:hover {
  cursor: pointer;
}
.content-nav span:hover{cursor: pointer;}
</style>